import Vue from "vue";

const STORAGE_KEY = "mi_admin_favorites";

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : { influencers: [], businesses: [] };
  } catch (e) {
    return { influencers: [], businesses: [] };
  }
}

const stored = load();

const state = Vue.observable({
  influencerIds: stored.influencers || [],
  businessIds: stored.businesses || []
});

function persist() {
  localStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      influencers: state.influencerIds,
      businesses: state.businessIds
    })
  );
}

export default {
  isFavoriteInfluencer(id) {
    return state.influencerIds.includes(id);
  },
  toggleInfluencerFavorite(id) {
    const index = state.influencerIds.indexOf(id);
    if (index === -1) state.influencerIds.push(id);
    else state.influencerIds.splice(index, 1);
    persist();
  },
  isFavoriteBusiness(id) {
    return state.businessIds.includes(id);
  },
  toggleBusinessFavorite(id) {
    const index = state.businessIds.indexOf(id);
    if (index === -1) state.businessIds.push(id);
    else state.businessIds.splice(index, 1);
    persist();
  }
};